<section
  class="home-cuenta"
  [id]="anchorId"
  aria-labelledby="home-cuenta-title"
>
  <div
    class="home-cuenta__container"
    [class.home-cuenta__container--natural-expanded]="naturalExpanded"
    [class.home-cuenta__container--juridica-expanded]="juridicaExpanded"
  >
    <div class="home-cuenta__title-block">
      <p class="home-cuenta__eyebrow">CREA TU CUENTA</p>
      <h2 id="home-cuenta-title" class="home-cuenta__title">
        Y conéctate con nuestros
        <span class="home-cuenta__title-accent">aliados financieros</span>
      </h2>
    </div>

    <div class="home-cuenta__visual" aria-hidden="true">
      <div
        class="home-cuenta__image-layer home-cuenta__image-layer--natural"
        [class.home-cuenta__image-layer--active]="perfilSeleccionado === 'natural'"
      >
        <img
          class="home-cuenta__image"
          [src]="imagenes.naturalSrc"
          alt=""
        />
      </div>

      <div
        class="home-cuenta__image-layer home-cuenta__image-layer--juridica"
        [class.home-cuenta__image-layer--active]="perfilSeleccionado === 'juridica'"
      >
        <img
          class="home-cuenta__image"
          [src]="imagenes.juridicaSrc"
          alt=""
        />
      </div>
    </div>

    <div class="home-cuenta__form-panel">
      <p class="home-cuenta__profile-question">¿Con que perfil te identificas?</p>

      <div class="home-cuenta__profile-tabs" role="tablist" aria-label="Perfil">
        <button
          type="button"
          class="home-cuenta__profile-btn"
          [class.home-cuenta__profile-btn--active]="isNatural()"
          role="tab"
          [attr.aria-selected]="isNatural()"
          (click)="setPerfil('natural')"
        >
          <span>Persona Natural</span>
          <span
            class="home-cuenta__profile-icon home-cuenta__profile-icon--face"
            aria-hidden="true"
          ></span>
        </button>

        <button
          type="button"
          class="home-cuenta__profile-btn"
          [class.home-cuenta__profile-btn--active]="!isNatural()"
          role="tab"
          [attr.aria-selected]="!isNatural()"
          (click)="setPerfil('juridica')"
        >
          <span>Persona Jurídica</span>
          <span
            class="home-cuenta__profile-icon home-cuenta__profile-icon--store"
            aria-hidden="true"
          ></span>
        </button>
      </div>

      <div
        class="home-cuenta__forms-stage"
        [class.home-cuenta__forms-stage--natural]="perfilSeleccionado === 'natural'"
        [class.home-cuenta__forms-stage--juridica]="perfilSeleccionado === 'juridica'"
      >
        <section
          class="home-cuenta__form-pane home-cuenta__form-pane--natural"
          [class.home-cuenta__form-pane--active]="perfilSeleccionado === 'natural'"
        >
          <app-home-cuenta-form-natural
            (visibleErrorsChange)="onNaturalVisibleErrors($event)"
          ></app-home-cuenta-form-natural>
        </section>

        <section
          class="home-cuenta__form-pane home-cuenta__form-pane--juridica"
          [class.home-cuenta__form-pane--active]="perfilSeleccionado === 'juridica'"
        >
          <app-home-cuenta-form-juridica
            (visibleErrorsChange)="onJuridicaVisibleErrors($event)"
          ></app-home-cuenta-form-juridica>
        </section>
      </div>
    </div>
  </div>
</section>
